import { INITIALIZE, SET_LAST_STEP, SET_SELECTED_SUBJECT, SET_SELECTED_GRADE, SET_CHILD_SCREEN_NAME, SET_BACK_BUTTON_LOADING, SET_BACK_BUTTON_NOT_LOADING,
  SET_ONBOARDING_QUESTIONS_OUTCOME_DATA, SET_SKIP_PERSONALISED, SET_SV_ONBOARDING_EVENT_PARAMS, RESET_SV_ONBOARDING_EVENT_PARAMS, SET_QUESTION_RESPONSE_DATA, SET_MENTOR_INFO } from './actionTypes';
import { fetchCoursesApi, ABTestDetailsAfterLogin } from '../../services/loggedout-api';
import { isTabletDevice, isMobileDevice } from '../../utils/web-helper';
import { AbTestDetails as AbTestDetailsLoggedIn } from '../../services/student-api';

export const setLastStep = step => dispatch => {
  dispatch({
    type: SET_LAST_STEP,
    payload: step
  })
};

export const initialise = data => async dispatch => {
  let res = {};
  let abtest = {};
  let abtestLoggedIn = {};
  try {
    res = await fetchCoursesApi();
    abtest = await ABTestDetailsAfterLogin();
    abtestLoggedIn = await AbTestDetailsLoggedIn();
  } catch(err) {
    console.log(err);
  }
  let payload = {
    ...res,
    ...data,
    skipPOQ: abtest.skip_poq,
    skipSubject: abtest.skip_poq_subject,
    skipForkScreen: abtest.skip_fork_screen,
    isLPABTest:
      abtestLoggedIn &&
      abtestLoggedIn.experiment_assigned &&
      abtestLoggedIn.experiment_assigned.includes(
        'LearningPartner-LearningPartner_On'
      ),
    storeLoaded: true,
  };
  dispatch({
    type: INITIALIZE,
    payload
  })
};

export const setChildScreenName = name => dispatch => {
  dispatch({
    type: SET_CHILD_SCREEN_NAME,
    payload: name
  })
};

export const setSelectedGrade = grade => dispatch => {
  dispatch({
    type: SET_SELECTED_GRADE,
    payload: grade
  })
}

export const setSelectedSubject = subject => dispatch => {
  dispatch({
    type: SET_SELECTED_SUBJECT,
    payload: subject
  })
}

export const setQuestionOutcomeData = (data, subject) => dispatch => {
  dispatch({
    type: SET_ONBOARDING_QUESTIONS_OUTCOME_DATA,
    payload: {
      data,
      subject
    }
  })
}

export const setSkipPersonalized = bool => dispatch => {
  dispatch({
    type: SET_SKIP_PERSONALISED,
    payload: bool
  })
}

export const setSVOnboardingEventParams = param => {
  return {
    type: SET_SV_ONBOARDING_EVENT_PARAMS,
    payload: param
  };
}

export const resetSVOnboardingEventParam = () => dispatch => {
  dispatch({
    type: RESET_SV_ONBOARDING_EVENT_PARAMS
  })
}

export const setBackButtonLoading = () => dispatch => {
  dispatch({
    type: SET_BACK_BUTTON_LOADING
  })
}

export const setBackButtonNotLoading = () => dispatch => {
  dispatch({
    type: SET_BACK_BUTTON_NOT_LOADING
  })
}

export const setQuestionResponsesData = (data, subject) => dispatch => {
  dispatch({
    type: SET_QUESTION_RESPONSE_DATA,
    payload: {
      data, subject
    }
  })
}

export const setMentorInfo = (data) => dispatch =>{
  dispatch({
    type: SET_MENTOR_INFO,
    payload: {
      data
    }
  })
}